import { Box, styled, Typography } from '@mui/material';

export const TemplateContainer = styled(Box)(
  ({ theme, $isSelected }) => `
  min-height: 100px;
  display: flex;
    flex-grow: 1;
    flex-direction: column;
    gap: 5px;
    width: 100%;
    align-items: center;
    justify-content: center;
    outline: 3px solid ${theme.palette.secondary.dark};
    background-color: ${theme.palette.secondary.contrastText};
    border-radius: 3px;
    color: ${theme.palette.secondary.dark};
    transition: all 0.1s ease-in-out;
    line-height:1;
    &:hover {
        outline: 3px solid ${theme.palette.primary.main};
        background-color: ${theme.palette.secondary.contrastText};
    }
    ${
      $isSelected &&
      `
        outline: 3px solid ${theme.palette.primary.main};
        background-color: ${theme.palette.secondary.contrastText};
    `
    }
`,
);

export const TemplateTitle = styled(Typography)(
  ({ theme }) => `
  font-weight: 500;
  font-size: 20px;
  text-align: center;
  color: ${theme.palette.text.primary};
`,
);

export const TemplateSubtitle = styled(Typography)(
  ({ theme }) => `
  font-weight: 500;
  font-size: 14px;
  padding: 0 5px;
  text-align: center;
  color: ${theme.palette.text.primary};
`,
);
